/**
 * Mary's navigation: every base screen, nothing removed, nothing added.
 * `screens: 'all'` means "the base admin as it is".
 */
const MARY_NAVIGATION = Object.freeze({
    screens: 'all',
    extraNav: Object.freeze([]),
});

export default MARY_NAVIGATION;
